import { isDefined, isSameId } from "../../helpers";
import { closeAllElements } from "../../actions/common";
export default function (store, { id }) {
    let { selected } = store.getState();
    if (!selected.length ||
        (isDefined(id) && !selected.some(i => isSameId(i, id)))) {
        return;
    }
    if (!isDefined(id)) {
        for (const deselected of selected) {
            store.in.exec("unselect-task", { id: deselected });
        }
        selected = [];
    }
    else {
        store.updateTask({ id, task: { selected: false } });
    }
    selected = selected.filter(selectedId => !isSameId(selectedId, id));
    closeAllElements(store);
    store.setState({ selected });
}
//# sourceMappingURL=unselect.js.map